// スクロール量に応じて #header に「-small」クラスを付け外し
// 条件: ページを少し（10px超）スクロールしたら付与、戻ったら削除

(function () {
  const header = document.getElementById("header");
  if (!header) return; // #header が存在しないページでは何もしない

  const THRESHOLD = 10; // 「少しスクロール」の閾値（px）
  let lastIsSmall = null; // 直近の状態を保存して不要なDOM操作を避ける
  let ticking = false; // rAFによるスロットリング

  const evaluate = () => {
    const isSmall = window.scrollY > THRESHOLD;
    if (isSmall !== lastIsSmall) {
      header.classList.toggle("-small", isSmall);
      lastIsSmall = isSmall;
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      evaluate();
      ticking = false;
    });
  };

  // 初期状態を反映（リロード時に既にスクロールされているケース）
  window.addEventListener("DOMContentLoaded", evaluate, { once: true });
  window.addEventListener("load", evaluate, { once: true });

  // スクロール監視（パフォーマンスのため passive）
  window.addEventListener("scroll", onScroll, { passive: true });
})();
